<template>
  <div class="q-pa-md">
    <div class="row q-col-gutter-sm">
      <div class="row col-12 text-brand-5" @click="voltar">
        <q-icon
          style="margin-top: 3px"
          size="sm"
          name="arrow_back_ios"
          class="cursor"
        />
        <p class="text-h6 text-brand-5 text-weight-bold titulo-pagina">
          Detalhe do Modelo: {{ modelo?.modeloNome }}
        </p>
      </div>
    </div>

    <div v-if="modelo" class="row q-my-md">
      <div
        class="row col-12 q-gutter-x-sm text-brand-5 text-weight-bold text-body"
      >
        <div class="col-md-3 col-sm-5 col-xs-12">
          <div class="q-ml-sm titulo-input">Nome do Modelo</div>
          <q-input
            outlined
            v-model="modelo.modeloNome"
            class="bg-brand-7 input"
            dense
            disable
          />
        </div>
        <div class="col-md-3 col-sm-5 col-xs-12">
          <div class="q-ml-sm titulo-input">Criador</div>
          <q-input
            outlined
            v-model="modelo.criadorNome"
            class="bg-brand-7 input"
            dense
            disable
          />
        </div>
      </div>
    </div>

    <div class="col-12 q-my-lg">
      <div class="row q-gutter-md items-end">
        <div class="col-md-3 col-sm-4 col-xs-12">
          <div class="q-ml-sm titulo-input">Tipo de Atributo</div>
          <q-select
            outlined
            dense
            v-model="novoAtributo.tipo"
            :options="tiposAtributos"
            option-label="label"
            option-value="value"
            label="Selecione o tipo"
            @update:model-value="carregarAtributosDisponiveis"
          />
        </div>
        <div class="col-md-4 col-sm-5 col-xs-12">
          <div class="q-ml-sm titulo-input">Atributo</div>
          <q-select
            outlined
            dense
            v-model="novoAtributo.atributo"
            :options="atributosDisponiveis"
            :option-label="getOptionLabel"
            :option-value="getOptionValue"
            label="Selecione o atributo"
            :disable="!novoAtributo.tipo"
          />
        </div>
        <div class="col-md-2 col-sm-2 col-xs-12">
          <q-btn
            label="Adicionar"
            color="primary"
            icon="add"
            no-caps
            class="btn"
            @click="adicionarAtributo"
            :disable="!novoAtributo.tipo || !novoAtributo.atributo"
          />
        </div>
      </div>
    </div>

    <div class="col-12 q-my-lg">
      <p class="text-brand-5 text-weight-bold q-ml-md titulo-table">
        Atributos do Modelo
      </p>

      <div v-if="atributosModelo.length === 0" class="text-center q-pa-lg">
        <p class="text-grey-6">Nenhum atributo adicionado ao modelo</p>
      </div>

      <div v-else class="q-mt-md">
        <q-tabs
          v-model="tabAtiva"
          dense
          class="text-brand-5"
          active-color="brand-5"
          indicator-color="brand-5"
          align="left"
        >
          <q-tab
            v-for="tab in tabsDisponiveis"
            :key="tab.name"
            :name="tab.name"
            :label="tab.label"
            :class="{ 'q-tab--active': tabAtiva === tab.name }"
          />
        </q-tabs>

        <q-separator />

        <q-tab-panels v-model="tabAtiva" animated>
          <q-tab-panel
            v-for="tab in tabsDisponiveis"
            :key="tab.name"
            :name="tab.name"
            class="q-pa-none q-mt-md"
          >
            <div
              v-if="getAtributosPorTipo(tab.type).length === 0"
              class="text-center q-pa-lg"
            >
              <p class="text-grey-6">
                Nenhum {{ tab.label.toLowerCase() }} adicionado ao modelo
              </p>
            </div>

            <div v-else class="row q-gutter-md">
              <div
                v-for="(atributo, index) in getAtributosPaginados(tab.type)"
                :key="index"
                class="col-xs-12 col-sm-6 col-md-4"
              >
                <q-card class="q-pa-md">
                  <div class="row items-center justify-between">
                    <div class="col-8">
                      <div class="text-weight-bold text-brand-5">
                        {{ getTipoLabel(atributo.atributoTipo) }}
                      </div>
                      <div class="text-body2 text-grey-7">
                        {{ getAtributoNome(atributo) }}
                      </div>
                    </div>
                    <div class="col-4 text-right">
                      <q-btn
                        icon="visibility"
                        v-if="atributo.atributoTipo !== 'encerramento'"
                        flat
                        round
                        color="primary"
                        size="sm"
                        @click="abrirModalDetalhes(atributo)"
                        class="q-mr-xs"
                      >
                        <q-tooltip>Ver Detalhes</q-tooltip>
                      </q-btn>
                      <q-btn
                        icon="delete"
                        flat
                        round
                        color="red"
                        size="sm"
                        @click="abrirModalConfirmarExclusaoAtributo(atributo)"
                      >
                        <q-tooltip>Excluir Modelo</q-tooltip>
                      </q-btn>
                    </div>
                  </div>
                </q-card>
              </div>
            </div>

            <div
              v-if="getTotalPaginas(tab.type) > 1"
              class="row justify-start q-mt-lg"
            >
              <q-pagination
                v-model="paginaAtual[tab.type]"
                color="brand-5"
                active-color="secondary"
                active-text-color="white"
                :max="getTotalPaginas(tab.type)"
                :max-pages="5"
                :boundary-numbers="false"
                :direction-links="true"
                size="sm"
                @update:model-value="(value) => mudarPagina(tab.type, value)"
              />
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </div>

    <q-dialog v-model="modalDetalhes" persistent>
      <q-card style="min-width: 600px; max-width: 80vw">
        <q-card-section class="row items-center q-pb-none">
          <div class="text-h6 text-primary">
            {{
              atributoDetalhes?.atributoTipo === "informacao"
                ? "Detalhes da Informação"
                : atributoDetalhes?.atributoTipo === "responsavel"
                ? "Detalhes do Responsável"
                : "Lista de Perguntas"
            }}
          </div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>

        <q-card-section>
          <div class="text-subtitle1 q-mb-md text-weight-bold">
            {{ getAtributoNome(atributoDetalhes) }}
          </div>

          <div
            v-if="perguntasDetalhes.length === 0"
            class="text-center q-pa-lg"
          >
            <p class="text-grey-6">
              {{
                atributoDetalhes?.atributoTipo === "informacao"
                  ? "Nenhuma informação encontrada"
                  : atributoDetalhes?.atributoTipo === "responsavel"
                  ? "Nenhum detalhe encontrado"
                  : "Nenhuma pergunta encontrada para esta atividade"
              }}
            </p>
          </div>

          <div v-else>
            <q-list separator>
              <q-item
                v-for="(item, index) in perguntasDetalhes"
                :key="index"
                class="q-pa-md"
              >
                <q-item-section>
                  <q-item-label
                    v-if="item.descricao"
                    class="text-weight-medium"
                  >
                    {{ index + 1 }}. {{ item.descricao }}
                  </q-item-label>
                  <div v-else-if="item.campo">
                    <q-item-label class="text-weight-bold text-primary q-mb-xs">
                      {{ item.campo }}
                    </q-item-label>
                    <q-item-label class="text-body2">
                      {{ item.valor }}
                    </q-item-label>
                  </div>
                </q-item-section>
              </q-item>
            </q-list>
          </div>
        </q-card-section>

        <q-card-actions align="top-right">
          <q-btn flat label="Fechar" color="brand-4" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <q-dialog v-model="modalConfirmarExclusaoAtributo" persistent>
      <q-card style="min-width: 400px">
        <q-card-section>
          <div class="text-h6 text-red">Confirmar Exclusão</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="text-body1">
            Tem certeza de que deseja remover o atributo
            <strong
              >"{{ getTipoLabel(atributoParaExcluir?.atributoTipo) }}"</strong
            >
            do modelo?
          </div>
          <div class="text-body2 text-grey-7 q-mt-sm">
            Esta ação não pode ser desfeita.
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            flat
            label="Cancelar"
            color="primary"
            @click="fecharModalConfirmarExclusaoAtributo"
          />
          <q-btn
            label="Excluir"
            color="red"
            @click="confirmarExclusaoAtributo"
            :loading="loadingExcluirAtributo"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();

    const modelo = ref(null);
    const atributosModelo = ref([]);
    const novoAtributo = ref({
      tipo: null,
      atributo: null,
    });

    const tiposAtributos = ref([
      { label: "Atividade", value: "atividade" },
      { label: "Questões de Encerramento", value: "encerramento" },
      { label: "Informações Adicionais", value: "informacao" },
      { label: "Responsáveis", value: "responsavel" },
    ]);

    const atributosDisponiveis = ref([]);
    const modalConfirmarExclusaoAtributo = ref(false);
    const atributoParaExcluir = ref(null);
    const loadingExcluirAtributo = ref(false);
    const modalDetalhes = ref(false);
    const atributoDetalhes = ref(null);
    const perguntasDetalhes = ref([]);
    const atividadesCache = ref({});
    const encerramentoCache = ref({});
    const informacaoCache = ref({});
    const responsavelCache = ref({});
    const tabAtiva = ref("atividade");

    const paginaAtual = ref({
      atividade: 1,
      encerramento: 1,
      informacao: 1,
      responsavel: 1,
    });
    const itensPorPagina = 16;

    const tabsDisponiveis = ref([
      { name: "atividade", label: "Atividades", type: "atividade" },
      {
        name: "encerramento",
        label: "Questões de Encerramento",
        type: "encerramento",
      },
      {
        name: "informacao",
        label: "Informações Adicionais",
        type: "informacao",
      },
      { name: "responsavel", label: "Responsáveis", type: "responsavel" },
    ]);

    const buscarDetalheModelo = async () => {
      try {
        const unidade = store.state.org.unidadeData;
        if (!unidade) return;

        const resposta = await store.dispatch("pdt/listarModelos", {
          modeloId: route.params.modeloId,
          unidadeId: unidade.id,
        });

        const modelos = resposta.data.resultado.dados || [];
        modelo.value = modelos.find((m) => m.modeloId == route.params.modeloId);

        if (modelo.value && modelo.value.atributos) {
          atributosModelo.value = modelo.value.atributos;
          await buscarNomesAtividades();
        }
      } catch (error) {
        console.error("Erro ao buscar detalhe do modelo:", error);
      }
    };

    const buscarNomesAtividades = async () => {
      const atividadesNoModelo = atributosModelo.value.filter(
        (atributo) => atributo.atributoTipo === "atividade"
      );

      for (const atributo of atividadesNoModelo) {
        if (!atividadesCache.value[atributo.atributoId]) {
          try {
            const unidade = store.state.org.unidadeData;
            if (!unidade) continue;

            const resposta = await store.dispatch(
              "pdt/buscarDetalheAtividade",
              {
                unidadeId: unidade.id,
                atividadeId: atributo.atributoId,
              }
            );

            const atividadeData = resposta.data.resultado.dados;
            if (atividadeData && atividadeData.nome) {
              atividadesCache.value[atributo.atributoId] = atividadeData.nome;
            }
          } catch (error) {
            console.error(
              `Erro ao buscar nome da atividade ${atributo.atributoId}:`,
              error
            );
          }
        }
      }

      const encerramentosNoModelo = atributosModelo.value.filter(
        (atributo) => atributo.atributoTipo === "encerramento"
      );

      if (encerramentosNoModelo.length > 0) {
        try {
          const unidade = store.state.org.unidadeData;
          if (unidade) {
            const resposta = await store.dispatch("pdt/listarEncerramento", {
              unidadeId: unidade.id,
            });

            const encerramentos = resposta.data.resultado.dados || [];

            for (const atributo of encerramentosNoModelo) {
              const encerramentoData = encerramentos.find(
                (e) => e.encerramentoId === atributo.atributoId
              );

              if (encerramentoData && encerramentoData.pergunta) {
                encerramentoCache.value[atributo.atributoId] =
                  encerramentoData.pergunta;
              }
            }
          }
        } catch (error) {
          console.error("Erro ao buscar nomes de encerramento:", error);
        }
      }

      const informacoesNoModelo = atributosModelo.value.filter(
        (atributo) => atributo.atributoTipo === "informacao"
      );

      if (informacoesNoModelo.length > 0) {
        try {
          const unidade = store.state.org.unidadeData;
          if (unidade) {
            const resposta = await store.dispatch(
              "pdt/receberConfiguraçõesInformacao",
              {
                unidadeId: unidade.id,
              }
            );

            const informacoes = resposta.data.resultado.dados || [];

            for (const atributo of informacoesNoModelo) {
              const informacaoData = informacoes.find((info, index) => {
                if (info.informacaoId === atributo.atributoId) return true;
                if (info.informacaoAdicionalId === atributo.atributoId)
                  return true;
                if (info.id === atributo.atributoId) return true;
                return index + 1 === atributo.atributoId;
              });

              if (informacaoData) {
                let valorCampo = "";
                if (informacaoData.areaTrabalho) {
                  valorCampo = informacaoData.areaTrabalho;
                } else if (informacaoData.observacao) {
                  valorCampo = informacaoData.observacao;
                } else if (informacaoData.recomendacao) {
                  valorCampo = informacaoData.recomendacao;
                } else if (informacaoData.outrasMedidas) {
                  valorCampo = informacaoData.outrasMedidas;
                } else if (informacaoData.aviso) {
                  valorCampo = informacaoData.aviso;
                }

                informacaoCache.value[atributo.atributoId] =
                  valorCampo || "Informação";
              }
            }
          }
        } catch (error) {
          console.error("Erro ao buscar nomes de informações:", error);
        }
      }

      const responsaveisNoModelo = atributosModelo.value.filter(
        (atributo) => atributo.atributoTipo === "responsavel"
      );

      if (responsaveisNoModelo.length > 0) {
        try {
          const unidade = store.state.org.unidadeData;
          if (unidade) {
            const resposta = await store.dispatch(
              "pdt/listarTiposResponsaveis",
              {
                unidadeId: unidade.id,
              }
            );

            const responsaveis = resposta.data.resultado.dados || [];

            for (const atributo of responsaveisNoModelo) {
              const responsavelData = responsaveis.find(
                (r) =>
                  (r.tipoResponsavelId ||
                    r.tipoReponsavelId ||
                    r.responsavelTipoId) === atributo.atributoId
              );

              if (responsavelData && responsavelData.tipo) {
                responsavelCache.value[atributo.atributoId] =
                  responsavelData.tipo;
              }
            }
          }
        } catch (error) {
          console.error("Erro ao buscar nomes de responsáveis:", error);
        }
      }
    };

    const carregarAtributosDisponiveis = async () => {
      if (!novoAtributo.value.tipo) {
        atributosDisponiveis.value = [];
        return;
      }

      try {
        const unidade = store.state.org.unidadeData;
        if (!unidade) return;

        let resposta;

        switch (novoAtributo.value.tipo.value) {
          case "atividade":
            resposta = await store.dispatch("pdt/buscarDetalheUnidade", {
              unidadeId: unidade.id,
              perPage: 100,
              page: 1,
            });
            atributosDisponiveis.value = resposta.data.resultado.dados || [];
            break;

          case "encerramento":
            resposta = await store.dispatch("pdt/listarEncerramento", {
              unidadeId: unidade.id,
            });
            atributosDisponiveis.value = resposta.data.resultado.dados || [];
            break;

          case "informacao": {
            resposta = await store.dispatch(
              "pdt/receberConfiguraçõesInformacao",
              {
                unidadeId: unidade.id,
              }
            );
            const informacoes = resposta.data.resultado.dados || [];

            atributosDisponiveis.value = informacoes.map((info, index) => ({
              informacaoId: index + 1,
              campo: info.areaTrabalho
                ? "Área Trabalho"
                : info.observacao
                ? "Observação"
                : info.recomendacao
                ? "Recomendação"
                : info.outrasMedidas
                ? "Outras Medidas"
                : info.aviso
                ? "Aviso"
                : "Informação",
              ...info,
            }));
            break;
          }

          case "responsavel":
            resposta = await store.dispatch("pdt/listarTiposResponsaveis", {
              unidadeId: unidade.id,
            });
            atributosDisponiveis.value = resposta.data.resultado.dados || [];
            break;
        }
      } catch (error) {
        console.error("Erro ao carregar atributos disponíveis:", error);
        atributosDisponiveis.value = [];
      }
    };

    const getOptionLabel = (option) => {
      if (!option) return "";

      switch (novoAtributo.value.tipo?.value) {
        case "atividade":
          return option.nome;
        case "encerramento":
          return option.pergunta;
        case "informacao":
          return option.campo;
        case "responsavel":
          return option.tipo;
        default:
          return (
            option.nome || option.pergunta || option.campo || option.tipo || ""
          );
      }
    };

    const getOptionValue = (option) => {
      if (!option) return null;

      switch (novoAtributo.value.tipo?.value) {
        case "atividade":
          return option.atividadeId || option.id;
        case "encerramento":
          return option.encerramentoId || option.id;
        case "informacao":
          return (
            option.informacaoId || option.informacaoAdicionalId || option.id
          );
        case "responsavel":
          return (
            option.tipoResponsavelId ||
            option.tipoReponsavelId ||
            option.responsavelTipoId ||
            option.id
          );
        default:
          return option.id;
      }
    };

    const getTipoLabel = (tipo) => {
      const tipoObj = tiposAtributos.value.find((t) => t.value === tipo);
      return tipoObj ? tipoObj.label : tipo;
    };

    const getAtributoNome = (atributo) => {
      if (atributo.atributoTipo === "atividade") {
        if (atividadesCache.value[atributo.atributoId]) {
          return atividadesCache.value[atributo.atributoId];
        }
        return `Atividade #${atributo.atributoId}`;
      }

      if (atributo.atributoTipo === "encerramento") {
        if (encerramentoCache.value[atributo.atributoId]) {
          return encerramentoCache.value[atributo.atributoId];
        }
        return `encerramento #${atributo.atributoId}`;
      }

      if (atributo.atributoTipo === "informacao") {
        if (informacaoCache.value[atributo.atributoId]) {
          return informacaoCache.value[atributo.atributoId];
        }
        return `informacao #${atributo.atributoId}`;
      }

      if (atributo.atributoTipo === "responsavel") {
        if (responsavelCache.value[atributo.atributoId]) {
          return responsavelCache.value[atributo.atributoId];
        }
        return `responsavel #${atributo.atributoId}`;
      }

      return `${atributo.atributoTipo} #${atributo.atributoId}`;
    };

    const adicionarAtributo = async () => {
      if (!novoAtributo.value.tipo || !novoAtributo.value.atributo) {
        return;
      }

      try {
        const atributoId = getOptionValue(novoAtributo.value.atributo);

        if (!atributoId) {
          quasar.notify({
            message:
              "Erro: ID do atributo não encontrado. Verifique os dados selecionados.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
              },
            ],
          });
          return;
        }

        await store.dispatch("pdt/adicionarAtributoModelo", {
          modeloId: route.params.modeloId,
          atributoId: atributoId,
          atributoTipo: novoAtributo.value.tipo.value,
        });

        quasar.notify({
          message: "Atributo adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });

        novoAtributo.value = {
          tipo: null,
          atributo: null,
        };
        atributosDisponiveis.value = [];

        buscarDetalheModelo();
      } catch (error) {
        console.error("Erro ao adicionar atributo:", error);
        console.error("Detalhes do erro:", {
          response: error.response?.data,
          status: error.response?.status,
        });

        let mensagemErro = "Erro ao adicionar atributo";
        if (error.response?.data?.erro?.mensagem) {
          mensagemErro = error.response.data.erro.mensagem;
        }

        quasar.notify({
          message: mensagemErro,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const removerAtributo = async (atributo) => {
      try {
        await store.dispatch("pdt/removerAtributoModelo", {
          modeloId: route.params.modeloId,
          atributoId: atributo.atributoId,
          atributoTipo: atributo.atributoTipo,
        });

        quasar.notify({
          message: "Atributo removido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });

        buscarDetalheModelo();
      } catch (error) {
        console.error("Erro ao remover atributo:", error);
        quasar.notify({
          message: "Erro ao remover atributo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const abrirModalConfirmarExclusaoAtributo = (atributo) => {
      atributoParaExcluir.value = atributo;
      modalConfirmarExclusaoAtributo.value = true;
    };

    const fecharModalConfirmarExclusaoAtributo = () => {
      modalConfirmarExclusaoAtributo.value = false;
      atributoParaExcluir.value = null;
    };

    const confirmarExclusaoAtributo = async () => {
      if (!atributoParaExcluir.value) return;

      loadingExcluirAtributo.value = true;

      try {
        await removerAtributo(atributoParaExcluir.value);
        fecharModalConfirmarExclusaoAtributo();
      } catch (error) {
        console.error("Erro ao confirmar exclusão do atributo:", error);
      } finally {
        loadingExcluirAtributo.value = false;
      }
    };

    const abrirModalDetalhes = async (atributo) => {
      atributoDetalhes.value = atributo;
      perguntasDetalhes.value = [];
      modalDetalhes.value = true;

      if (atributo.atributoTipo === "atividade") {
        try {
          const unidade = store.state.org.unidadeData;
          if (!unidade) return;

          const resposta = await store.dispatch("pdt/buscarDetalheAtividade", {
            unidadeId: unidade.id,
            atividadeId: atributo.atributoId,
          });

          const atividadeData = resposta.data.resultado.dados;
          perguntasDetalhes.value = atividadeData.perguntas || [];
          atividadesCache.value[atributo.atributoId] = atividadeData.nome;
        } catch (error) {
          console.error("Erro ao buscar perguntas da atividade:", error);
          perguntasDetalhes.value = [];
        }
      } else if (atributo.atributoTipo === "informacao") {
        try {
          const unidade = store.state.org.unidadeData;
          if (!unidade) return;

          const resposta = await store.dispatch(
            "pdt/receberConfiguraçõesInformacao",
            {
              unidadeId: unidade.id,
            }
          );

          const informacoes = resposta.data.resultado.dados || [];
          const informacaoData = informacoes.find((info, index) => {
            if (info.informacaoId === atributo.atributoId) return true;
            if (info.informacaoAdicionalId === atributo.atributoId) return true;
            if (info.id === atributo.atributoId) return true;
            return index + 1 === atributo.atributoId;
          });

          if (informacaoData) {
            const detalhes = [];

            if (informacaoData.areaTrabalho) {
              detalhes.push({
                campo: "Área de Trabalho",
                valor: informacaoData.areaTrabalho,
              });
            }

            if (informacaoData.observacao) {
              detalhes.push({
                campo: "Observação",
                valor: informacaoData.observacao,
              });
            }

            if (informacaoData.recomendacao) {
              detalhes.push({
                campo: "Recomendação",
                valor: informacaoData.recomendacao,
              });
            }

            if (informacaoData.outrasMedidas) {
              detalhes.push({
                campo: "Outras Medidas",
                valor: informacaoData.outrasMedidas,
              });
            }

            if (informacaoData.aviso) {
              detalhes.push({
                campo: "Aviso",
                valor: informacaoData.aviso,
              });
            }

            perguntasDetalhes.value = detalhes;
          }
        } catch (error) {
          console.error("Erro ao buscar detalhes da informação:", error);
          perguntasDetalhes.value = [];
        }
      } else if (atributo.atributoTipo === "responsavel") {
        try {
          const unidade = store.state.org.unidadeData;
          if (!unidade) return;

          const resposta = await store.dispatch("pdt/listarTiposResponsaveis", {
            unidadeId: unidade.id,
          });

          const responsaveis = resposta.data.resultado.dados || [];
          const responsavelData = responsaveis.find(
            (r) =>
              (r.tipoResponsavelId ||
                r.tipoReponsavelId ||
                r.responsavelTipoId) === atributo.atributoId
          );

          if (responsavelData) {
            const detalhes = [];

            if (responsavelData.tipo) {
              detalhes.push({
                campo: "Tipo de Responsável",
                valor: responsavelData.tipo,
              });
            }

            if (responsavelData.obrigatorio !== undefined) {
              detalhes.push({
                campo: "Obrigatório",
                valor: responsavelData.obrigatorio ? "Sim" : "Não",
              });
            }

            if (responsavelData.terceirizado !== undefined) {
              detalhes.push({
                campo: "Terceirizado",
                valor: responsavelData.terceirizado ? "Sim" : "Não",
              });
            }

            if (responsavelData.emissor !== undefined) {
              detalhes.push({
                campo: "Emissor",
                valor: responsavelData.emissor ? "Sim" : "Não",
              });
            }

            if (responsavelData.unidadeNome) {
              detalhes.push({
                campo: "Unidade",
                valor: responsavelData.unidadeNome,
              });
            }

            perguntasDetalhes.value = detalhes;
          }
        } catch (error) {
          console.error("Erro ao buscar detalhes do responsável:", error);
          perguntasDetalhes.value = [];
        }
      } else {
        perguntasDetalhes.value = atributo.perguntas || [];
      }
    };

    const getAtributosPorTipo = (tipo) => {
      return atributosModelo.value.filter(
        (atributo) => atributo.atributoTipo === tipo
      );
    };

    const getAtributosPaginados = (tipo) => {
      const atributos = getAtributosPorTipo(tipo);
      const inicio = (paginaAtual.value[tipo] - 1) * itensPorPagina;
      const fim = inicio + itensPorPagina;
      return atributos.slice(inicio, fim);
    };

    const getTotalPaginas = (tipo) => {
      const total = getAtributosPorTipo(tipo).length;
      return Math.ceil(total / itensPorPagina);
    };

    const mudarPagina = (tipo, pagina) => {
      paginaAtual.value[tipo] = pagina;
    };

    const voltar = () => {
      router.push({ name: "pdt-modelos" });
    };

    onMounted(buscarDetalheModelo);

    return {
      modelo,
      atributosModelo,
      novoAtributo,
      tiposAtributos,
      atributosDisponiveis,
      modalConfirmarExclusaoAtributo,
      atributoParaExcluir,
      loadingExcluirAtributo,
      modalDetalhes,
      atributoDetalhes,
      perguntasDetalhes,
      atividadesCache,
      encerramentoCache,
      informacaoCache,
      responsavelCache,
      tabAtiva,
      paginaAtual,
      itensPorPagina,
      tabsDisponiveis,
      buscarDetalheModelo,
      carregarAtributosDisponiveis,
      getOptionLabel,
      getOptionValue,
      getTipoLabel,
      getAtributoNome,
      adicionarAtributo,
      removerAtributo,
      abrirModalConfirmarExclusaoAtributo,
      fecharModalConfirmarExclusaoAtributo,
      confirmarExclusaoAtributo,
      abrirModalDetalhes,
      getAtributosPorTipo,
      getAtributosPaginados,
      getTotalPaginas,
      mudarPagina,
      voltar,
    };
  },
};
</script>

<style scoped>
.titulo-input {
  font-size: 14px;
  font-weight: bold;
  color: #707070;
  margin-bottom: 8px;
}

.titulo-table {
  font-size: 17px;
}

.cursor {
  cursor: pointer;
}

:deep(.q-tabs) {
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
  padding: 4px;
}

:deep(.q-tab) {
  border-radius: 6px;
  margin: 0 2px;
  color: #6c757d;
  font-weight: 500;
  min-height: 40px;
  padding: 0 16px;
  transition: all 0.3s ease;
}

:deep(.q-tab--active) {
  background-color: #fff;
  color: var(--q-primary) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

:deep(.q-tab:hover:not(.q-tab--active)) {
  background-color: rgba(255, 255, 255, 0.6);
  color: var(--q-primary);
}

:deep(.q-tabs__content) {
  background-color: #f8f9fa;
}

:deep(.q-tab-panels) {
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

:deep(.q-separator) {
  display: none;
}

/* Estilos para os cards dos atributos */
:deep(.q-card) {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

:deep(.q-card:hover) {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

@media (max-width: 600px) {
  .titulo-pagina {
    font-size: 14px;
  }

  .titulo-input {
    font-size: 12px;
  }

  .input {
    font-size: 12px;
  }

  .btn {
    font-size: 12px;
  }

  .titulo-table {
    font-size: 14px;
  }

  :deep(.q-tab) {
    min-height: 36px;
    padding: 0 12px;
    font-size: 12px;
  }

  :deep(.q-tabs) {
    padding: 2px;
  }
}
</style>
